import {Component, Input, OnInit} from '@angular/core';
import {AudioService} from '../../../services/audio/audio.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import { LangSrcService } from '../../../services/lang-src/lang-src.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-vocabulary-item',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './vocabulary-item.component.html',
  styleUrls: ['./vocabulary-item.component.scss']
})
export class VocabularyItemComponent implements OnInit {

  @Input() word: any;
  @Input() audioIconColor = 'secondary';
  @Input() supPinyin: boolean;

  // New explicit inputs (used by dictionary page for cleaner binding)
  @Input() langSrcName: string;
  @Input() langTgtName: string;
  @Input() langTgtCode: string;
  @Input() displayPhonetic: boolean;

  constructor(
    public audioSrv: AudioService,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService
  ) {}

  ngOnInit() {
    // Fallback to service values if inputs not provided
    if (!this.langSrcName) { this.langSrcName = this.langSrcSrv.current?.name; }
    if (!this.langTgtName) { this.langTgtName = this.langTgtSrv.current?.name; }
    if (!this.langTgtCode) { this.langTgtCode = this.langTgtSrv.current?.code; }
    if (this.displayPhonetic === undefined) { this.displayPhonetic = this.langTgtSrv.current?.displayPhonetic; }
  }

  col(codeLang: string): string {
    switch (codeLang) {
      case 'zh':
        return this.supPinyin ? 'col-3' : 'col-4';
      case 'en':
      case 'it':
      case 'ru':
      case 'fr':
      case 'toeic':
        return 'col-4';
      default:
        return 'col-3';
    }
  }
}
